import AllhomesSearchPriceRange from './allhomes-search-price-range';
export default AllhomesSearchPriceRange;